import { Alert, Group, Loader, Text } from "@mantine/core";

type Props = {
  count: number;
  loading?: boolean;
  title: string;
  header?: string;
};

function DiscountGroupInfo({ count, loading, title, header }: Props) {
  return (
    <Alert color="gray" title={header}>
      {" "}
      <Group justify="space-between">
        <Text c="gray" size="sm">
          {title}
        </Text>
        {loading ? (
          <Loader color="gray" type="dots" size="xs" />
        ) : (
          <Text c="gray" size="sm">
            {count} نفر
          </Text>
        )}
      </Group>
    </Alert>
  );
}

export default DiscountGroupInfo;
